import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Download } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import TrayCsvUploadStatusEnum from '../../constants/enums/tray-csv-upload-status-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  TrayHistoryDefaultSortColumnOrder,
  TrayHistoryFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import IPageInfo, { IPageLimitInfo } from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { ITrayHistoryFilter } from '../../models/ITrayHIstoryFilter';
import { ITrayFile } from '../../models/response/ITrayResponse';
import Pagination from '../../shared-components/Grid/Pagination';
import { NOHistoryIcon } from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import TrayHistoryFilterComponent from './forms/history-fiter-form';

const TrayPrintFilesHistoryDetails = (props: any) => {
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    TrayHistoryDefaultSortColumnOrder
  );
  const [filterObj, setFilterObj] = useState<ITrayHistoryFilter>(
    TrayHistoryFilterInitialState
  );
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const { trayManagementStore, preferencesStore } = useStore();
  const {
    GetTrayFilesHistoryService,
    trayFilesHistory,
    DownloadTrayFilesHistoryService,
    trayFiles,
  } = trayManagementStore;

  const { userSetting, setUserSetting } = preferencesStore;

  const tray: ITrayFile[] = trayFilesHistory;

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  function getFieldName(field: string): string {
    switch (field) {
      case 'TrayId':
        return 'tray_id';
      case 'OrderId':
        return 'order_id';
      case 'EUOrderNo':
        return 'eu_order_no';
      case 'CustomerDueDate':
        return 'customer_due_date';
      case 'PlanedDueDate':
        return 'planed_due_date';
      case 'ProductId':
        return 'product_id';
      case 'CustomerId':
        return 'customer_id';
      default:
        return 'tray_id';
    }
  }

  const createQueryString = (filter: ITrayHistoryFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: ITrayHistoryFilter) => {
    const filter = createQueryString({
      ...object,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
    });
    // getTrayListServiceHandler(filter);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    // props.filterPopupToggleHandler();
    // closePanelhandler();
    setIsFilterCleared(false);
  };

  const filterParams = (obj: ITrayHistoryFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      // getTrayListServiceHandler(filter);
      // closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    // props.filterPopupToggleHandler();
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: trayFiles?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [trayFiles]);

  useEffect(() => {
    GetTrayFilesHistoryService(
      Number(getTenantIdFromLocalStorage()),
      pageInfo.currentPage,
      pageLimitInfo.pageLimit,
      filterObj.StartDate,
      filterObj.EndDate
    );
  }, [filterObj, pageInfo.currentPage, pageLimitInfo.pageLimit]);

  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-sm-center">
        {/* <Pagination
          isRefreshPage={false}
          totalPages={pageInfo.totalPages}
          pageLimit={pageLimitInfo.pageLimit}
          onPageChanged={onPageChanged}
          disablePagination={disablePagination}
          setIsRefreshPage={setIsRefreshPage}
        /> */}
      </div>
      <div>
        <TrayHistoryFilterComponent
          initialValues={TrayHistoryFilterInitialState}
          submitHandler={filterHandler}
          filterParmas={filterParams}
          isLoading={false}
          isFilterCleared={isFilterCleared}
        />
      </div>
      {tray && tray.length > 0 ? (
        <>
          <div className="history-table row-eq-height mt-3">
            <Table
              className="download-print border"
              bordered
              hover
              responsive
            >
              <thead>
                <tr>
                  <th>{formatMessage('date')}</th>
                  <th style={{ textAlign: 'center' }}>
                    {formatMessage('file_name')}
                  </th>
                  <th>{formatMessage('status')}</th>
                  {/* <th>{formatMessage('download')}</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tray.map((file: ITrayFile, idx: number) => (
                  <tr
                    key={idx}
                    className={idx % 2 === 0 ? '' : ''}
                  >
                    <td className="text-center cursor-default">
                      {file.ImportTime}
                    </td>
                    <td
                      title={file.FileName}
                      className="text-center cursor-default"
                    >
                      {file.FileName.substring(0, 10) + '...'}
                    </td>
                    <td className="processType cursor-default">
                      <div
                        className={` ${
                          file.Status === TrayCsvUploadStatusEnum[0]
                            ? 'printSuccess text-white fw-normal badge'
                            : file.Status === TrayCsvUploadStatusEnum[2]
                              ? 'printFailed text-white fw-normal badge'
                              :file.Status === TrayCsvUploadStatusEnum[3]
                              ? 'testingProcess text-white fw-normal badge'
                              : file.Status === TrayCsvUploadStatusEnum[1]
                                ? 'testingProcess text-white fw-normal badge'
                                : ''
                        }`}
                      >
                        {formatMessage(file.Status)}
                      </div>
                    </td>
                    <td>
                      <div
                        className="download-print-icon cursor-pointer text-dangers"
                        onClick={(e) => {
                          DownloadTrayFilesHistoryService(
                            Number(getTenantIdFromLocalStorage()),
                            file.FileId
                          );
                        }}
                      >
                        <Download size={18} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      ) : (
        <div className="no-data-history message tray-no-history">
          <NOHistoryIcon />
          <h3 className="fw-bold display-6">
            {formatMessage('no_history_message')}
          </h3>
        </div>
      )}
      {tray.length > 0 ? (
        <div className="tableFooter d-flex justify-content-between p-2 pb-0 pagination-history-detail">
          <div className="show-total">
            <FormattedMessage id="show" />
            <select
              data-testid="pageSelect"
              className="pageLimit"
              onChange={onPageLimitChanged}
              value={pageLimitInfo.pageLimit}
            >
              {pageLimitOptions.map((op: any) => (
                <option
                  key={op}
                  value={op}
                >
                  {op}
                </option>
              ))}
            </select>
          </div>
          <div>
            <Pagination
              isRefreshPage={false}
              totalPages={pageInfo.totalPages}
              pageLimit={pageLimitInfo.pageLimit}
              onPageChanged={onPageChanged}
              disablePagination={disablePagination}
              setIsRefreshPage={setIsRefreshPage}
              currentPage={pageInfo.currentPage}
              totalRecords={trayFiles.PagingDetails.TotalRecords}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default observer(TrayPrintFilesHistoryDetails);
